const Logger = require('@KrashidBuilt/common/utils/logger');

const logger = new Logger('helpers/parts');

const getFiltered = (parts, filters) => {
    logger.extra({ parts, filters });

    // no filters supplied
    if (!filters && Object.keys(filters)?.length === 0) {
        return parts;
    }

    // only get keys with values
    const keys = Object.keys(filters).map((k) => k && filters[k] ? k : false).filter((k) => k);

    if (keys?.length == 0) {
        return parts;
    }

    return parts.filter((p) => p.filter && keys.every((k) => String(p.filter[k]) === String(filters[k])));
};

module.exports = {
    getFiltered,
};